import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Home from './pages/Home';
import About from './pages/about';
import Vendors from './pages/vendors';
import Contact from './pages/contact';
import Register from './pages/register';
import ScrollToTop from './components/scrolltotop';
import { useLang } from './context/langcontext';
import './styles/style.css';

// ✅ Immediately set theme on page load (before React mounts)
const initTheme = (() => {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem("theme") || "dark";
    document.documentElement.setAttribute("data-theme", saved);
    return saved;
  }
  return "dark";
})();

// ✅ Get initial lang
const getInitialLang = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("lang") || "en"; // default English
  }
  return "en";
};

function App() {
  const { lang, setLang } = useLang();

  // ✅ Theme state is synced instantly with DOM
  const [theme, setTheme] = useState(initTheme);

  // ✅ Language loads once on mount
  useEffect(() => {
    const savedLang = getInitialLang();
    setLang(savedLang);
  }, [setLang]);

  // ✅ Keep language in localStorage
  useEffect(() => {
    if (lang) {
      localStorage.setItem("lang", lang);
    }
  }, [lang]);

  // ✅ Keep theme in localStorage + DOM attribute
  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute("data-theme", theme);
      localStorage.setItem("theme", theme);
    }
  }, [theme]);

  return (
    <div
      className={`App ${theme}`}
      dir={lang === 'ar' ? 'rtl' : 'ltr'} // ✅ RTL/LTR works instantly
    >
      <Router>
        <ScrollToTop />
        <Navbar setTheme={setTheme} theme={theme} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
